import { Anchor, Button, Card, Group, Stack, Text, ThemeIcon } from '@mantine/core';
import { IconBook, IconExternalLink } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useLanguageAwareRouting } from '@/hooks/useLanguageAwareRouting';
import { PageHeader } from '../../components/Common/PageHeader';
import { DOCS_SECTIONS } from '../../components/Docs';

export function AccountDocsPage() {
  const { t } = useTranslation();
  const { createLanguageURL } = useLanguageAwareRouting();
  const docsUrl = createLanguageURL('/docs');

  return (
    <Stack gap="lg">
      <PageHeader title={t('account_docs.title')} subtitle={t('account_docs.description')} />

      <Group gap="sm">
        <Button
          component="a"
          href={`#${docsUrl}`}
          target="_blank"
          rel="noopener noreferrer"
          leftSection={<IconBook size={16} />}
          rightSection={<IconExternalLink size={14} />}
        >
          {t('account_docs.openDocs')}
        </Button>
      </Group>

      <Card withBorder radius="md" p="lg" mt="md">
        <Text fw={600} size="sm" mb="md">
          {t('account_docs.jumpTo')}
        </Text>
        <Stack gap="xs">
          {DOCS_SECTIONS.map((section) => {
            const Icon = section.icon;
            return (
              <Anchor
                key={section.id}
                component={Link}
                to={`${docsUrl}?section=${section.id}`}
                target="_blank"
                rel="noopener noreferrer"
                underline="hover"
                style={{ display: 'flex', alignItems: 'center', gap: 12 }}
              >
                <ThemeIcon size="md" radius="xl" color={section.color} variant="light">
                  <Icon size={16} />
                </ThemeIcon>
                <Text size="sm">{t(section.titleKey)}</Text>
              </Anchor>
            );
          })}
        </Stack>
      </Card>
    </Stack>
  );
}
